import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom';
import './ThreatIntelFeed.scss'
import ThreatIntelList from './ThreatIntelList'
import ThreatIntelFilter from './ThreatIntelFilter'
import ThreatIntelGrid from './ThreatIntelGrid'
import { loadThreatIntel, changeFilters, changeSorting, setPageNo } from '../store/entities/threatintel'
import Pagination from './common/paginator/pagination'
import LoaderWrapper from './common/LoaderWrapper/LoaderWrapper'

class ThreatIntelFeed extends Component {
  state = {
    viewType: 'list', // default view type
    resetOnChange: true,
  }

  componentDidMount() {
    this.setState({ viewType: this.props.viewType })
    this.props.loadThreatIntel(this.props.filters, this.props.sorting, this.props.pageNo, this.props.pageSize, this.props.selectedCustomer?.id)
    
  }

  componentDidUpdate(prevProps) {
      if(prevProps.filters !== this.props.filters || prevProps.sorting !== this.props.sorting) {
        this.setState({ resetOnChange: !this.state.resetOnChange})
        this.props.setPageNo(1);
        this.props.loadThreatIntel(this.props.filters, this.props.sorting, 1, this.props.pageSize, this.props.selectedCustomer?.id)
      }
  }

  handleViewSelect = (viewType) => {
    this.setState({ viewType: viewType })
  }


  handleDetails = (record) => {
    const context = this.props.context ? this.props.context : "threat-intel-feed"
    this.props.history.push(`/threat-intel-feed/${record.id}`, {context : context})
  }

  handleSearch = (srchTxt) => {
    const { filters } = this.props
    let parsedFilters = filters ? filters.split(',') : []
    parsedFilters = parsedFilters.filter(filter => !filter.startsWith('brndName|'))
    parsedFilters.push(`brndName|${srchTxt}`)
    this.props.changeFilters(parsedFilters.join(','))
    this.setState({ resetOnChange: true })
  }

  parseSearchBrand = () => {
    const { filters } = this.props
    let parsedFilters = filters ? filters.split(',') : []
    parsedFilters = parsedFilters.filter(filter => filter.startsWith('brndName|'))
    return parsedFilters.length > 0 ? parsedFilters[0].split('|')[1] : '';
  }

  parseRemoveRepeat = () => {
    const { filters } = this.props
    let parsedFilters = filters ? filters.split(',') : []
    parsedFilters = parsedFilters.filter(filter => filter.startsWith('rmRepeatURL|'))
    return parsedFilters.length > 0 ? parsedFilters[0].split('|')[1] === 'true' : false;
  }


  handleSelect = (selectedOption) => {
    const { filters, changeFilters } = this.props
    let parsedFilters = filters ? filters.split(',') : []
    parsedFilters = parsedFilters.filter(filter => !filter.startsWith('dtcTime|'))
    parsedFilters.push(`dtcTime|${selectedOption.value}`)
    changeFilters(parsedFilters.join(','))
  }

  handleRemoveRepeatURL = (e) => {
    const { filters, changeFilters } = this.props
    let parsedFilters = filters ? filters.split(',') : []
    if (e.target.checked) {
      parsedFilters = parsedFilters.filter(filter => !filter.startsWith('rmRepeatURL|'))
      parsedFilters.push(`rmRepeatURL|true`)
    } else {
      parsedFilters = parsedFilters.filter(filter => !filter.startsWith('rmRepeatURL|'))
    }
    changeFilters(parsedFilters.join(','))
  }

  getPrevPageData = (pageNo, pageSize) => {
    
    this.props.loadThreatIntel(this.props.filters, this.props.sorting, pageNo, pageSize, this.props.selectedCustomer?.id);
    this.props.setPageNo(pageNo);
 }
  
  getNextPageData = (pageNo, pageSize) => {

    this.props.loadThreatIntel(this.props.filters, this.props.sorting, pageNo, pageSize, this.props.selectedCustomer?.id);
    this.props.setPageNo(pageNo);
  }

render() {
    const { viewType } = this.state
    const context = this.props.context ? this.props.context : 'threat-intel-feed'
    const showUpdatePopover = context === "threat-intel-feed" && this.props.tokenRoles === 'PixmAdmin';
    const viewTypeComponentMap = {
      'grid': ThreatIntelGrid,
      'list': ThreatIntelList,
    }

    const ViewComponent = viewTypeComponentMap[viewType] || ThreatIntelList

    return (
        <div>
            <ThreatIntelFilter 
                handleViewSelect={this.handleViewSelect} 
                viewType={viewType} 
                handleSearch={this.handleSearch} 
                changeFilters={this.props.changeFilters} 
                handleSelect={this.handleSelect} 
                handleRemoveRepeatURL={this.handleRemoveRepeatURL}
                parseSearchBrand={this.parseSearchBrand}
                parseRemoveRepeat={this.parseRemoveRepeat}
            />
            {
              this.props.loading || this.props.unverifyLoading || this.props.events.length === 0 ?
            <LoaderWrapper 
              loading={this.props.loading || this.props.unverifyLoading} 
              data={this.props.events} styles={{ minHeight: '500px', padding: '30px' }} 
              placeholderText={"No Threats Detected"}
            /> 
            :
            <>
              <ViewComponent
                  onDetails={this.handleDetails}
                  handleViewSelect={this.handleViewSelect}
                  tokenRoles={this.props.tokenRoles}
                  handleSearch={this.handleSearch}
                  changeFilters={this.props.changeFilters}
                  changeSorting={this.props.changeSorting}
                  pageNo={this.props.pageNo}
                  showUpdatePopover={showUpdatePopover}
              />
            
            <div className={`d-flex justify-content-center align-items-end`} >
            <Pagination
              initialPageNo={this.props.pageNo}
              isLastPage={this.props.isLastPage}
              getNextPageData={this.getNextPageData}
              getPrevPageData={this.getPrevPageData}
              pageSize={this.props.pageSize}
              resetOnChange={this.state.resetOnChange}
              loaderFlag={this.props.loading}
              />
            </div>
            </>
            } 
        </div>
    )
}
}

const mapStateToProps = (state) => ({
  events : state.entities.threatintel.events,
  filters: state.entities.threatintel.filters,
  sorting : state.entities.threatintel.sorting,
  isLastPage: state.entities.threatintel.isLastPage,
  loading: state.entities.threatintel.eventsLoading,
  pageSize: state.entities.threatintel.pageSize,
  displaySize: state.entities.threatintel.displaySize,
  tokenRoles: state.entities.user.roles,
  unverifyLoading: state.entities.threatintel.unverifyLoading,
  pageNo : state.entities.threatintel.pageNo,
  selectedCustomer : state.entities.customers.selected,
})

const mapDispatchToProps = (dispatch) => ({
  loadThreatIntel: (filters, sorting, pageNo, pageSize, cid) => dispatch(loadThreatIntel(filters, sorting, pageNo, pageSize, cid)),
  changeFilters: (filters) => dispatch(changeFilters(filters)),
  changeSorting: (sorting) => dispatch(changeSorting(sorting)),
  setPageNo: (pageNo) => dispatch(setPageNo({ pageNo })),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ThreatIntelFeed))